import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import HttpBackend from 'i18next-http-backend'

import { initReactI18next } from 'react-i18next'

const supportedLangs = ['ru', 'kk']

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: supportedLangs,
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    lowerCaseLng: true,
    cleanCode: true,
    supportedLngs: supportedLangs,
    nonExplicitSupportedLngs: true,
    load: 'languageOnly',
    detection: {
      order: ['localStorage', 'querystring', 'cookie', 'navigator', 'htmlTag', 'path', 'subdomain'],
      caches: ['localStorage'],
      lookupLocalStorage: 'locale',
    },
    backend: {
      loadPath: '/locales/{{lng}}.json',
    },
    react: {
      useSuspense: true,
    },
    ns: ['auth'],
    defaultNS: 'auth',
  })

export default i18n
